export default __webpack_public_path__ + "static/media/rnr-sports-table-1.3675f961.webp";